export default "__VITE_ASSET__Crm2MIIK__"